import * as type from './type'
import * as selector from './selector'
import * as customerSelector from '../selector'
import { get, post } from '../../../../../util/api'
import { enrichComment, enrichCommentList } from '../../../../process/state/instance-detail/enrich-process-instance'

export const changeIsCommentInternal = (name, value) => ({
    type: type.CHANGE_IS_COMMENT_INTERNAL,
    payload: {
        name,
        value,
    },
})

export const changeProcessComment = (name, value) => ({
    type: type.CHANGE_PROCESS_COMMENT,
    payload: {
        name,
        value,
    },
})

export const commentProcessInstanceRequest = () => ({
    type: type.COMMENT_PROCESS_INSTANCE_REQUEST,
    payload: {},
})

export const commentProcessInstanceSuccess = (comment) => ({
    type: type.COMMENT_PROCESS_INSTANCE_SUCCESS,
    payload: {
        comment,
    },
})

export const commentProcessInstanceError = (error) => ({
    type: type.COMMENT_PROCESS_INSTANCE_ERROR,
    payload: {
        error,
    },
})

export const commentProcessInstance = () => (dispatch, getState) => {
    dispatch(commentProcessInstanceRequest())

    const state = getState()
    const processInstanceList = selector.selectProcessInstanceList(state)
    const isInternal = selector.selectIsInternal(state)
    const processInstanceId = processInstanceList[processInstanceList.length - 1].id
    const commentText = selector.selectCommentText(state)

    post('/api/process/instance/comment', {
        processInstanceId,
        commentText,
        isInternal,
    })
        .then((comment) => {
            enrichComment(state, comment)
            dispatch(commentProcessInstanceSuccess(comment))
        })
        .catch(error => {
            dispatch(commentProcessInstanceError(error))
        })
}

export const findProcessCommentRequest = () => ({
    type: type.FIND_PROCESS_COMMENT_REQUEST,
})

export const findProcessCommentSuccess = (processList) => ({
    type: type.FIND_PROCESS_COMMENT_SUCCESS,
    payload: {
        processList,
    },
})

export const findProcessCommentError = (error) => ({
    type: type.FIND_PROCESS_COMMENT_ERROR,
    payload: {
        error,
    },
})

export const findProcessComment = () => (dispatch, getState) => {
    const state = getState()
    const customerId = customerSelector.selectCustomerId(state)
    if (!customerId) {
        return
    }

    dispatch(findProcessCommentRequest())
    get('/api/customer/find-process-comment?customerId=' + customerId)
        .then(processList => {
            const state = getState()
            for (let index = 0; index < processList.length; index++) {
                const process = processList[index]
                enrichCommentList(state, process)
            }

            dispatch(findProcessCommentSuccess(processList))
        })
        .catch(error => {
            dispatch(findProcessCommentError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/tab-comments/action.js